import {} from './types.js'

export default {
  activeAdmins: state => {
    return state.admin_list.filter(a => a.status === 'active') || []
  },
  dropdownAdmins: (state, getters) => {
    return getters.activeAdmins.map(admin => ({
      text: admin.full_name,
      value: admin.full_name
    }))
  },
  dropdownAdminsNames: (state, getters) => {
    return [...getters.activeAdmins.map(admin => admin.full_name), 'NULL']
  },
  getAdminsNames: state => {
    return state.admin_list.map(a => (a.full_name))
  },
  adminFullList: state => {
    return state.admin_list || []
  },
  currentUser: state => {
    return state.active_admin
  },
  getAdminByName: state => name => {
    return state.admin_list.find(admin => admin.full_name === name)
  }
}
